// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__dzndw","formControl":"addForm_formControl__2zKh1","list":"addForm_list__rvDsN","btnWrpper":"addForm_btnWrpper__x1WK5"};